<template>
  <div class="text-container">
    <h1 class="medium-h1">
      {{ $t('servicesTitle.title1') }} <span class="gradient-text2">{{ $t('servicesTitle.title2') }}</span>
    </h1>
    <p>{{ $t('servicesTitle.description') }}</p>
  </div>
</template>

<script>
export default {
  name: 'ServicesTitle',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
z-index: 1;
  text-align: center;
}

.text-container p {
  width: 70%;

}

</style>
